import fetch from "../utils/Api";
import axios from "axios";
import { AUTH_TOKEN_KEY } from "../constants/";
import {
  KAFAIR_RAFFLE_GROUP,
  KA_FAIR_RAFFLE,
  KA_FAIR_RAFFLE_LIST,
  SET_USER_RAFFLE_TICKET,
  SET_PRODUCT_RAFFLE_COUNT,
  KA_FAIR_RAFFLE_LIST_CLOSED,
  KA_PREVIEW_RAFFLE,
  GET_COLLECTION_KICKFAIR,
  GET_COLLECTION_STEAL_DEAL,
  GET_COLLECTION_STEAL_DEAL_LIST,
  GET_COLLECTION_SPECIAL_DEALS_GOLD,
  GET_COLLECTION_SPECIAL_DEALS_CAPSULE,
  GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD,
  GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE,
  GET_LOCAL_BRANDS_PRODUCT,
  GET_LOCAL_BRANDS_BRANDS,
  GET_IMAGE_BANNER_LOCAL_BRANDS,
  SCROLL_TO_SECTION,
  GET_KICKFAIR_SETTING,
  GET_IMAGE_BANNER_MERCHANDISE,
  GET_MERCHANDISE_PRODUCT,
  KA_POST_RAFFLE_ENTRY,
  GET_COLLECTION_LOCAL_BRANDS,
  GET_COLLECTION_EXCLUSIVE_LAUNCH,
  GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST,
  GET_COLLECTION_SURPRISE_DROP,
  GET_COLLECTION_SURPRISE_DROP_LIST,
  GET_POPULAR_BRANDS,
  GET_SLIDER_PROMO,
  GET_COLLECTION_SNEAKERS_NOVEMBAZAR,
  GET_COLLECTION_STREETWEAR_NOVEMBAZAR,
  GET_COLLECTION_LUXURY_NOVEMBAZAR,
  GET_COLLECTION_LIFESTYLE_NOVEMBAZAR,
  GET_RAFFLE_BANNER,
  SET_PRODUCT_RAFFLE_ENTRY,
  GET_COLLECTION_FLASH_SALE
} from "../constants/kafairConstants";

import {
  GET_COLLECTION_UNDER_RETAIL,
  GET_COLLECTION_MERCHANDISE,
  API_BASE_URL,
  GET_PRE_VERIFIED_COLLECTION_LIST
} from "../constants"

export const getRaffleGroup = () => ({
  type: KAFAIR_RAFFLE_GROUP,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get(`/settings?keyword=home_raffle_group2`)
    .then(response => response.data)
});

export const getPreVerifiedCollectionList = () => ({
  type: GET_PRE_VERIFIED_COLLECTION_LIST,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get(`/settings?name=pre_verified_collection`)
    .then(response => response.data)
})

const CollectionType = name => {
  switch (name) {
    case "exclusive_launch":
      return GET_COLLECTION_EXCLUSIVE_LAUNCH;
    case "steal_deal":
      return GET_COLLECTION_STEAL_DEAL;
    case "local_brands":
      return GET_COLLECTION_LOCAL_BRANDS;
    case "surprise_drop":
      return GET_COLLECTION_SURPRISE_DROP;

    default:
      return GET_COLLECTION_KICKFAIR;
  }
};

const CollectionListType = name => {
  switch (name) {
    case "steal_deal":
      return GET_COLLECTION_STEAL_DEAL_LIST;
    case "special_deals_gold":
      return GET_COLLECTION_SPECIAL_DEALS_GOLD;
    case "special_deals_capsule":
      return GET_COLLECTION_SPECIAL_DEALS_CAPSULE;
    case "official_merchandise":
      return GET_MERCHANDISE_PRODUCT;
    case "local_brands":
    case "madeindonesia":
      return GET_COLLECTION_LOCAL_BRANDS;
    case "flash_sale":
      return GET_COLLECTION_FLASH_SALE;

    default:
      return null;
  }
};

const BannerCollection = name => {
  switch (name) {
    case "special_deals_gold":
      return GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD;
    case "special_deals_capsule":
      return GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE;
    case "local_brands":
      return GET_IMAGE_BANNER_LOCAL_BRANDS;
    case "official_merchandise":
      return GET_IMAGE_BANNER_MERCHANDISE;
    case "under_retail":
      return GET_COLLECTION_UNDER_RETAIL;
    case "merchandise":
      return GET_COLLECTION_MERCHANDISE;

    default:
      return null;
  }
};

const getProducts = name => {
  switch (name) {
    case "local_brands":
      return GET_LOCAL_BRANDS_PRODUCT;
    case "steal_deal":
      return GET_COLLECTION_STEAL_DEAL_LIST;
    case "special_deals_gold":
      return GET_COLLECTION_SPECIAL_DEALS_GOLD;
    case "special_deals_capsule":
      return GET_COLLECTION_SPECIAL_DEALS_CAPSULE;
    case "sneakers_harbolnas":
      return GET_COLLECTION_SNEAKERS_NOVEMBAZAR;
    case "streetwear_harbolnas":
      return GET_COLLECTION_STREETWEAR_NOVEMBAZAR;
    case "luxury_harbolnas":
      return GET_COLLECTION_LUXURY_NOVEMBAZAR;
    case "lifestyle_harbolnas":
      return GET_COLLECTION_LIFESTYLE_NOVEMBAZAR;
    case "under_retail":
      return GET_COLLECTION_UNDER_RETAIL;
    case "merchandise":
      return GET_COLLECTION_MERCHANDISE;

    default:
      return null;
  }
};

const NoCategoryListType = name => {
  switch (name) {
    case "exclusive_launch":
      return GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST;
    case "surprise_drop":
      return GET_COLLECTION_SURPRISE_DROP_LIST;

    default:
      return null;
  }
};

export const getRafflesToday = group_name => {
  const decoded_group_name =
    (group_name &&
      group_name.toLowerCase() &&
      group_name &&
      group_name.toLowerCase().replace(/\s/gi, "+")) ||
    "";
  return {
    type: KA_FAIR_RAFFLE,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`/raffle-today?group_name=${decoded_group_name}`)
      .then(response => response.data)
  };
};

export const getRaffleList = (group_name, date, page = 1) => {
  return {
    type: KA_FAIR_RAFFLE_LIST,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`raffle-${date}?group_name=${group_name}`)
      .then(response => {
        return {
          group_name,
          ...response.data
        };
      })
  };
};

export const getUserRaffleTickets = () => {
  return {
    type: SET_USER_RAFFLE_TICKET,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`raffles/raffle_entries2?status=unredeemed`)
      .then(response => response.data)
  };
};

export const getSliderSection = (params) => {
  return {
    type: GET_SLIDER_PROMO,
    payload: axios.get(`${API_BASE_URL}/promos`, params)
      .then(value => value.data)
      .catch(e => e)
  }
}

export const getProductRaffleCount = (raffle_id, ticket_type) => {
  return {
    type: SET_PRODUCT_RAFFLE_COUNT,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`raffles/raffle_entries2`, {
        params: { raffle_id, redeemed: 1, redeemed: true }
      })
      .then(response => ({
        ticket_type,
        raffle_id,
        ...response.data
      }))
  };
};

export const getClosedRaffleList = group_name => {
  return {
    type: KA_FAIR_RAFFLE_LIST_CLOSED,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`raffle-closed?group_name=${group_name}`)
      .then(response => response.data)
  };
};

export const getPreviewRaffle = () => {
  return {
    type: KA_PREVIEW_RAFFLE,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`preview-raffles`)
      .then(response => response.data)
  };
};

export const getCollectionPrefix = (payload, name) => {
  return {
    type: CollectionType(name),
    payload: fetch()
      .get("collections", { params: payload })
      .then(response => response.data)
  };
};

export const getCollectionList = (category, slug, payload, name) => ({
  type: CollectionListType(name),
  payload: fetch()
    .get(`collections/${category}/${slug}`, { params: payload })
    .then(response => response.data)
});

export const getImageBanner = (slug, name, category = "kafair") => ({
  type: BannerCollection(name),
  payload: fetch()
    .get(`collections/${category}/${slug}`)
    .then(response => response.data)
});

export const getRaffleBanner = (slug, name, category = "kafair") => ({
  type: GET_RAFFLE_BANNER,
  payload: fetch()
    .get(`${category}/${slug}`)
    .then(response => response.data)
});

export const getCollectionProductBrands = (payload, name) => ({
  type: getProducts(name),
  payload: fetch()
    .get("products/browse", { params: payload })
    .then(response => response.data)
});

export const getCollectionAllCategory = (payload, name) => ({
  type: CollectionListType(name),
  payload: fetch()
    .get("products/browse", { params: payload })
    .then(response => response.data)
});

export const getCollectionBrands = (payload, slug) => ({
  type: GET_LOCAL_BRANDS_BRANDS,
  payload: fetch()
    .get(`collections/all/${slug}`, { params: payload })
    .then(response => response.data)
});

export const scrollToSection = section => ({
  type: SCROLL_TO_SECTION,
  payload: section
});

export const getKickFairSetting = () => ({
  type: GET_KICKFAIR_SETTING,
  payload: fetch()
    .get("settings?keyword=ka_fair")
    .then(res => res.data)
});

export const postRaffleEntry = raffles => {
  return {
    type: KA_POST_RAFFLE_ENTRY,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .post("/raffles/raffle_entries", {
        raffles
      })
      .then(response => {
        const sumOfTicket = raffles.reduce(
          (total, currentVal) => total + parseInt(currentVal.quantity),
          0
        );

        return {
          sumOfTicket,
          ...response.data
        };
      })
  };
};

export const getCollectionNoCategory = (id, payload, name) => ({
  type: NoCategoryListType(name),
  payload: fetch()
    .get(`collections/${id}/product_variants`, { params: payload })
    .then(response => response.data)
});

export const getPopularBrands = (category = "sneakers") => ({
  type: GET_POPULAR_BRANDS,
  payload: fetch()
    .get("brands/populars", { params: category })
    .then(response => response.data)
});

export const getProductBrandByFilter = (payload) => ({
  type: GET_LOCAL_BRANDS_PRODUCT,
  payload: fetch()
    .get("products/browse", { params: payload })
    .then(response => response.data)
})

export const getProductRaffleEntry = (raffle_id, ticket_type) => {
  return {
    type: SET_PRODUCT_RAFFLE_ENTRY,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`raffles/raffle_entries2`, {
        params: { raffle_id, redeemed: 1, redeemed: true }
      })
      .then(response => ({
        ticket_type,
        raffle_id,
        ...response.data
      }))
  };
};